import { render, staticRenderFns } from "./SalesGroup.vue?vue&type=template&id=1ee5a935&scoped=true"
import script from "./SalesGroup.vue?vue&type=script&lang=js"
export * from "./SalesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee5a935",
  null
  
)

export default component.exports